import type { FaireProductEntity } from "../../entity_types/product";

export const p_fxyq3y2qn3: FaireProductEntity = {
  token: "p_fxyq3y2qn3",
  type: "product",
  name: "12 Handmade Dream of Ocean Notecards 4x6 with Envelopes Blank Folded",
  brandName: "Blue Morning Expressions",
  imageUrl:
    "https://cdn.faire.com/fastly/eb212f10f5e3d6d0ded262241fea68c3a34ffff219531445ebb3c0cac547df2c.jpeg",
  priceDollars: 6.47,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a0525ac41c5324cf30205505237077dfd8962ec71aded6c482992ccecc547d4f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
